
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBatteryVerticalPluggedNoCharge25 as ObiBatteryVerticalPluggedNoCharge25Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-battery-vertical-plugged-no-charge-25.js';
 
 
 

 
 export const ObiBatteryVerticalPluggedNoCharge25 = createComponent({
   react: React,
   tagName: 'obi-battery-vertical-plugged-no-charge-25',
   elementClass: ObiBatteryVerticalPluggedNoCharge25Element,
   events: {
     
   }
  });
 
 